export default __webpack_public_path__ + "static/media/2.322d4717.jpg";